import { StoryDetailPage } from './StoryDetailPage'
import { withStoryDetailPage } from './withStoryDetailPage'

const ConnectedStoryDetail = withStoryDetailPage(StoryDetailPage)

export { ConnectedStoryDetail as StoryDetailPage }
